import { Controller, Control, FieldErrors, Field } from "react-hook-form";

import { FormField, FBasicPropos } from "../../interfaces/User.interface";
import FMultiRowComponent from "./fields/FMultiRowComponent";
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { FTextField } from "./fields/FTextField";
import { FSelectField } from "./fields/FSelectField";
import { FCheckField } from "./fields/FCheckField";
import { FSignPad } from "./fields/FSignPad";
import { FCameraCapture } from "./fields/FCameraCapture";
import { FNumberField } from "./fields/FNumberField";
import FAutoComplete from "./fields/FAutoComplete";
import { FDateInput } from "./fields/FDateInput";
import { FPasswordField } from "./fields/FPasswordField";
import { FPhoneField } from "./fields/FPhoneField";

import { FCoursePreviewField } from "./fields/FCoursePreviewField";



export const FormBuilder = (
    formFields: FormField[],
    control: Control<any>,
    errors: FieldErrors,
    onFieldChange?: (fieldName: string, value: any) => void
) => {

    const formComponent = formFields.map((field, index) => {
        switch (field.questionType) {
            //增加course类型
            case "course":
                return (
                    <FCoursePreviewField
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                );

            case "text":
                return (
                    <FTextField
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                );
            case "select":
                const options = field.options || []; // Ensure options is an array
                return (
                    <FSelectField
                        key={index}
                        field={{ ...field, options }}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                );
            case "checkbox":
                return (
                    <FCheckField
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                );
            case "sign":
                return (
                    <FSignPad
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                );
            case "multi-row":
                return (
                    <FMultiRowComponent
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                );
            case "number":
                return (
                    <FNumberField
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                );
            case "phone":
                return (
                    <FPhoneField
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                );
            case "autocomplete":
                return (
                    <FAutoComplete
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                        onFieldChange={onFieldChange}
                    />
                );
            case "date":
                return (
                    <FDateInput
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />

                );
            case "password":
                return (
                    <FPasswordField
                        key={index}
                        field={field}
                        control={control}
                        errors={errors}
                        props={field.props}
                    />
                )
            default:
                return null;
        }
    });

    return (
        <>
            {formComponent}
        </>
    );
};

export {
    FTextField,
    FSelectField,
    FCheckField,
    FSignPad,
    FCameraCapture,
};
